import { SelectionModel } from '@angular/cdk/collections';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { User } from 'cloud-shared-lib';
import { BehaviorSubject, debounceTime, distinctUntilChanged, fromEvent, Observable, Subject, takeUntil } from 'rxjs';
import { IUserResponse, ProfileService } from '../../profile.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'cutting-appoint-manager-dialog',
  templateUrl: './cutting-appoint-manager-dialog.component.html',
  styleUrls: ['./cutting-appoint-manager-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CuttingAppointManagerDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('filter', { static: true }) filter: ElementRef;
  @HostListener('keydown.escape', ['$event']) clearSearch(event: KeyboardEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.filter.nativeElement.value = '';
  }

  paginationModel: BehaviorSubject<PageEvent> = new BehaviorSubject({ length: 0, pageIndex: 0, pageSize: 10 });
  managers$: Observable<IUserResponse>;

  displayedColumns = ['select', 'snp'];

  totalCount = 0;
  selection = new SelectionModel<User>(false, []);
  unsubscribe$: Subject<void> = new Subject();

  constructor(
    public dialogRef: MatDialogRef<CuttingAppointManagerDialogComponent>,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    this.addListners();
  }

  getUsers(): void {
    this.managers$ = this.profileService.getManagers(
      this.paginationModel.value.pageIndex,
      this.paginationModel.value.pageSize,
      this.filter.nativeElement.value
    );
  }

  saveAndClose(): void {
    if (this.selection.selected.length > 0) {
      this.dialogRef.close(this.selection.selected[0]);
    } else {
      this.dialogRef.close(undefined);
    }
  }

  ngAfterViewInit(): void {
    this.getUsers();
  }

  private addListners(): void {
    fromEvent(this.filter.nativeElement, 'keyup')
      .pipe(debounceTime(250), distinctUntilChanged(), takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.getUsers();
      });
  }
}
